import { useState } from "react";
import { Play } from "lucide-react";

export const ytId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([\w-]{11})/);
  if (m) return m[1];
  const m2 = url.match(/[?&]v=([\w-]{11})/);
  if (m2) return m2[1];
  return url.trim().length === 11 ? url.trim() : "";
};

export const VideoCard = ({ video }) => {
  const [play, setPlay] = useState(false);
  const id = ytId(video.youtube_url);
  if (!id) return null;
  return (
    <div data-testid={`video-${video.id}`} className="group overflow-hidden rounded-2xl border border-white/10 bg-[#14161A] transition-colors hover:border-amber-500/40">
      <div className="relative aspect-video bg-black">
        {play ? (
          <iframe
            className="absolute inset-0 h-full w-full"
            src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
            title={video.title || "Video"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button onClick={() => setPlay(true)} data-testid={`video-play-${video.id}`} aria-label={`Spela ${video.title || "video"}`} className="absolute inset-0 h-full w-full">
            <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt={video.title || ""} loading="lazy" className="h-full w-full object-cover opacity-80 transition-opacity group-hover:opacity-100" />
            <span className="absolute inset-0 grid place-items-center">
              <span className="grid h-16 w-16 place-items-center rounded-full bg-amber-500 text-black shadow-lg transition-transform group-hover:scale-110">
                <Play className="ml-1 h-7 w-7" fill="currentColor" />
              </span>
            </span>
            {video.year && <span className="absolute left-3 top-3 rounded bg-black/70 px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-amber-500">{video.year}</span>}
          </button>
        )}
      </div>
      <div className="p-5">
        {video.title && <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">{video.title}</h3>}
        {video.description && <p className="mt-2 text-sm leading-relaxed text-white/60">{video.description}</p>}
      </div>
    </div>
  );
};
